export interface FaqImage {
  src: string
  alt: string
}

export type FaqBlock = string | { quote: string }

export interface FaqItem {
  question: string
  answer: FaqBlock[]
  bullets?: string[]
  image?: FaqImage
}

export const SHARED_FAQS = {
  whatIsForgd: {
    question: 'What is Forgd?',
    answer: [
      'Forgd is a comprehensive, free-to-use platform designed to support blockchain projects with tokenomics design, market maker engagement, exchange listing, liquidity monitoring, cap table management, and financial planning. Aimed at democratizing access to essential tools and advisory services, Forgd empowers projects to launch and manage their tokens effectively within the blockchain ecosystem.',
    ],
  },
  freeAccount: {
    question: 'Is it free to create an account on Forgd?',
    answer: [
      'Yes, creating an account on Forgd is completely free. Projects can access a wide range of tools and services without any upfront costs, making it an accessible solution for blockchain entrepreneurs at any stage of their project\'s lifecycle.',
    ],
  },
  selfServiceProducts: {
    question: 'Does Forgd offer self-service products?',
    answer: [
      'Yes, Forgd offers a variety of self-service products that allow projects to independently manage tokenomics, engage with market makers, and prepare for exchange listings using our platform\'s automated tools and resources.',
    ],
  },
  costToUse: {
    question: 'How much does it cost to use Forgd?',
    answer: [
      'Forgd is free-to-use for all blockchain projects. You can create an account at zero-cost and access our self-service tools at any time, without a consultation. If you are currently working with an advisor, they can also access the Forgd suite of tools entirely free of charge. If you are interested in engaging the Forgd team for consulting services, we offer white-glove advisory via application only. Learn more about Forgd consulting and advisory services on our Pricing page.',
    ],
  },
  consultingServices: {
    question: 'Does Forgd offer consulting & advisory services to blockchain projects?',
    answer: [
      'Yes, Forgd provides consulting and advisory services, offering hands-on support from experienced advisors to help blockchain projects navigate the complexities of launching and managing a token successfully. These services are offered to select projects and are available via application only. Learn more about Forgd consulting and advisory services on our Pricing page.',
    ],
  },
  tokenomicsDesign: {
    question: 'Can Forgd help with Tokenomics Design?',
    answer: [
      'Yes, Forgd offers robust tools for Tokenomics Design, enabling projects to create, test, and refine their token economics through advanced simulations. These tools are designed to help projects establish a strong economic foundation, ensuring their token\'s utility and value are optimized for long-term success.',
    ],
  },
  tokenDesigner: {
    question: 'Can Forgd help me design Tokenomics for my project?',
    answer: [
      'Yes. “Token Designer” by Forgd enables projects to create, test, and refine their token economics (“Tokenomics”) via a free-to-use application. We provide templates, post-TGE performance simulations, and comparative analytics that help you understand potential impacts of different token models. This tool helps you visualize how changes in parameters can affect the token\'s utility and market dynamics, aiding in crafting a balanced and effective token strategy.',
    ],
  },
  hireMarketMaker: {
    question: 'I want to hire a Market Maker. Can Forgd help?',
    answer: [
      'Absolutely, Forgd can facilitate your engagement with experienced market makers to enhance your token\'s liquidity and trading performance. Our platform connects you with reputable market makers, ensuring your token achieves optimal market presence and stability. Best of all, Forgd is free-to-use for blockchain projects.',
    ],
  },
  monitorMarketMaker: {
    question: 'I want to make sure my Market Maker is doing their job. Can Forgd help?',
    answer: [
      '“Market Maker Monitoring” by Forgd allows you to track all essential trade activity from all market makers. Forgd integrates directly with Market Makers & Exchanges to process data on depth, volume, and spreads and allows projects to track these key performance indicators from a free-to-use dashboard. This ensures transparent engagements and accountability for all, and allows projects to maximize the value of their engagements.',
    ],
  },
  scheduleConsultation: {
    question: 'How do I schedule a 1-on-1 consultation with the Forgd team?',
    answer: [
      'To schedule a 1-on-1 consultation, visit our book a consultation page and select a convenient time. This feature allows you to directly book a session with our experts to discuss your project\'s specific needs.',
    ],
  },
} satisfies Record<string, FaqItem>
